
export class CSVExporter {
	static toString (points) {
		let string = '';

		let attributes = Object.keys(points.data)
			.filter(a => a !== 'normal')
			.sort((a, b) => {
				if (a === 'position') return -1;
				if (b === 'position') return 1;
				if (a === 'rgba') return -1;
				if (b === 'rgba') return 1;
			});

		let headerValues = [];
		for (let attribute of attributes) {
			let itemSize = points.data[attribute].length / points.numPoints;

			if (attribute === 'position') {
				headerValues = headerValues.concat(['x', 'y', 'z']);
			} else if (attribute === 'rgba') {
				headerValues = headerValues.concat(['r', 'g', 'b', 'a']);
			} else if (itemSize > 1) {
				for (let i = 0; i < itemSize; i++) {
					headerValues.push(`${attribute}_${i}`);
				}
			} else {
				headerValues.push(attribute);
			}
		}
		string = headerValues.join(', ') + '\n';

		for (let i = 0; i < points.numPoints; i++) {
			let values = [];

			for (let attribute of attributes) {
				let itemSize = points.data[attribute].length / points.numPoints;
				let value = points.data[attribute]
					.subarray(itemSize * i, itemSize * i + itemSize)
					.join(', ');
				values.push(value);
			}

			string += values.join(', ') + '\n';
		}

		return string;
	}

	static toCsv (points) {
		let string = '';
		let headerValues = ["X", "Y", "Distance D", "Hauteur H", "Altitude min", "Altitude max", "Typologie T"];
		let values = [];
		string = headerValues.join(', ') + '\n';

		for (let i = 0; i < points.length; i++) {
			values = [];

			let x = points[i].e;
			let y = points[i].n;
			let distance = points[i].xa.toFixed(2);
			let height = (points[i].za.toFixed(2) - points[i].zb.toFixed(2)).toFixed(2);
			let typology = points[i].typologie;
			let altitude_min = points[i].zb.toFixed(2);
			let altitude_max = points[i].za.toFixed(2);

			values.push(x, y, distance, height, altitude_min, altitude_max, typology);
			string += values.join(', ') + '\n';
		}

		return string;
	}
};
